export default __webpack_public_path__ + "static/media/logistar.915e72ab.ico";